import { toStringBigDecimal } from '@0xtorch/big-decimal'
import type { Action, Transfer } from '@0xtorch/core'
import type { ParseToActions } from '../../types'
import { getAsset } from '../../utils/getAsset'
import type { Deposit } from './schema'

export const parseDepositHistoriesToActions: ParseToActions<Deposit> = ({
  data,
  cryptoCurrencies,
  fiatCurrencies,
}): readonly Action[] => {
  // 時価総額降順で cryptoCurrencies をソート
  const sortedCryptoCurrencies = cryptoCurrencies.toSorted((a, b) => {
    if (a.market?.marketCapUsd === undefined) {
      return -1
    }
    if (b.market?.marketCapUsd === undefined) {
      return 1
    }
    return a.market.marketCapUsd > b.market.marketCapUsd ? -1 : 1
  })
  const actions: Action[] = []
  for (const item of data) {
    // SUCCESS 以外はスキップ
    if (item.status !== 'SUCCESS') {
      continue
    }
    // item.currency から asset を取得
    const asset = getAsset({
      symbol: item.currency,
      cryptoCurrencies: sortedCryptoCurrencies,
      fiatCurrencies,
    })
    if (asset === undefined) {
      throw new Error(`asset not found: ${item.currency}`)
    }
    const transfer: Transfer | undefined =
      item.fee.value > 0n
        ? {
            asset,
            from: undefined,
            to: undefined,
            amount: item.fee,
            price: undefined,
            direction: 'out',
          }
        : undefined
    const source = `kucoin_deposit_${item.walletTxId}`
    const comment = `Deposit ${toStringBigDecimal(item.amount)}[${item.currency}] to ${item.chain}.${item.address} on ${item.walletTxId}`
    const action: Action =
      transfer === undefined
        ? {
            type: 'ignore',
            source,
            order: 0,
            comment,
            app: undefined,
            timestamp: item.createdAt,
            evidence: 'system-rule',
            transfers: [],
          }
        : {
            type: 'fee',
            source,
            order: 0,
            comment,
            app: undefined,
            timestamp: item.createdAt,
            evidence: 'system-rule',
            transfers: [transfer],
          }
    actions.push(action)
  }
  return actions
}
